<template>
  <div class="card tm-table-card border-0">
    <div class="card-header border-0 bg-transparent pt-4 pb-2 px-4">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="icon-box-header me-3">
            <i class="fas fa-list-ul text-white"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold text-dark opacity-75 text-uppercase letter-spacing-1">
              Atividades Lançadas
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-0">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted small fw-bold">Sincronizando atividades...</p>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-hover align-middle mb-0 tm-v2-table">
          <thead>
            <tr class="total-summary-row">
              <th colspan="3" class="ps-4">Total Acumulado</th>
              <th class="total-time">{{ secondsToHours(totalSpent) }}</th>
              <th colspan="5"></th>
            </tr>
            <tr>
              <th class="ps-4" width="130px">Data</th>
              <th width="80px">Início</th>
              <th width="80px">Fim</th>
              <th width="100px">Total</th>
              <th>Atividade</th>
              <th>Classificação</th>
              <th>Cliente</th>
              <th>Observação</th>
              <th class="text-end pe-4" width="100px">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tasksMade.length === 0">
              <td colspan="9" class="text-center py-5">
                <div class="empty-state">
                  <i class="fas fa-calendar-day mb-3 text-light"></i>
                  <p class="text-muted mb-0">Nenhum lançamento para este período.</p>
                </div>
              </td>
            </tr>

            <tr v-for="task in tasksMade" :key="task.id" class="tm-row">
              <td class="ps-4">
                <date-picker 
                  v-model="task.made_at_view"
                  format="DD/MM/YYYY" 
                  value-type="format"
                  style="max-width: 130px"
                  @change="onDateChange(task)"
                />
              </td>
              <td>
                <input 
                  v-mask="'##:##'"
                  class="form-control table-input"
                  v-model="task.started_at" 
                  @blur="$emit('edit', task)"
                />
              </td>
              <td>
                <input 
                  v-mask="'##:##'"
                  class="form-control table-input"
                  v-model="task.finished_at" 
                  @change="$emit('edit', task)"
                />
              </td>
              <td>
                <span class="badge bg-soft-dark text-dark fw-bold">
                  {{ secondsToHours(task.time_spent) }}
                </span>
              </td>
              <td>
                <v-select 
                  :reduce="t => t.id" 
                  label="name"
                  v-model="task.task.data.id" 
                  :options="tasks" 
                  @input="$emit('edit', task)"
                  class="table-select"
                  append-to-body
                />
              </td>
              <td>
                <v-select 
                  :reduce="t => t.id" 
                  label="name"
                  v-model="task.task_type.data.id" 
                  :options="taskTypes" 
                  @input="$emit('edit', task)"
                  class="table-select"
                  append-to-body
                />
              </td>
              <td>
                <v-select 
                  :reduce="c => c.id" 
                  label="name"
                  v-model="task.customer.data.id" 
                  :options="customers"
                  :disabled="Boolean(task.customer_service_id)" 
                  @input="$emit('edit', task)"
                  class="table-select"
                  append-to-body
                />
              </td>
              <td>
                <input 
                  class="form-control table-input"
                  v-model="task.note" 
                  @change="$emit('edit', task)"
                  placeholder="..."
                />
              </td>
              <td class="text-end pe-4">
                <div class="d-flex justify-content-end gap-1">
                  <button class="btn btn-sm btn-icon btn-outline-primary" title="Replicar" @click="$emit('replay', task)">
                    <i class="fas fa-reply"></i>
                  </button>
                  <button class="btn btn-sm btn-icon btn-outline-danger" title="Excluir" @click="$emit('delete', task.id)">
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'

export default {
  name: 'TasksMadeTable',
  components: { DatePicker, vSelect },
  props: {
    tasksMade: { type: Array, default: () => [] },
    tasks: Array,
    taskTypes: Array,
    customers: Array,
    totalSpent: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  watch: {
    tasksMade: {
      immediate: true,
      handler(val) {
        if (val) {
          val.forEach(t => {
            if (!t.made_at_view) {
              const d = new Date(t.made_at)
              t.made_at_view = `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
            }
          })
        }
      }
    }
  },
  methods: {
    secondsToHours(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00:00'
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.floor(seconds % 60)
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    onDateChange(task) {
      if (task.made_at_view) {
        const parts = task.made_at_view.split('/')
        task.made_at = new Date(`${parts[2]}-${parts[1]}-${parts[0]} 12:00:00`)
      }
      this.$emit('edit', task)
    }
  }
}
</script>

<style scoped lang="sass">
.tm-table-card
  border-radius: 24px
  background: white
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05)
  margin-bottom: 2rem

.icon-box-header
  width: 38px
  height: 38px
  background: linear-gradient(135deg, #2d3436 0%, #636e72 100%)
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: center
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2)

.letter-spacing-1
  letter-spacing: 1px

.tm-v2-table
  thead th
    background: #f8f9fa
    border-bottom: 2px solid #f1f2f6
    color: #a4b0be
    font-weight: 800
    font-size: 0.7rem
    text-transform: uppercase
    letter-spacing: 1px
    padding-top: 15px
    padding-bottom: 15px

.total-summary-row
  background-color: #f1f2f6 !important
  th
    background-color: #f1f2f6 !important
    color: #2d3436 !important
    font-size: 0.85rem !important
    padding-top: 10px !important
    padding-bottom: 10px !important
  .total-time
    color: #0984e3 !important
    font-weight: 900 !important

.tm-row
  transition: all 0.2s
  &:hover
    background-color: #fcfcfd

.table-input
  border: 1px solid transparent
  background: transparent
  font-size: 0.85rem
  padding: 4px 8px
  height: 32px
  transition: all 0.2s
  &:focus
    border-color: #0984e3
    background: white
    box-shadow: 0 0 0 3px rgba(9, 132, 227, 0.1)

.table-select
  --vs-border-color: transparent
  --vs-dropdown-bg: white
  --vs-font-size: 0.85rem
  min-width: 150px
  
  ::v-deep .vs__dropdown-toggle
    border: 1px solid transparent
    background: transparent
    padding: 0
    height: 32px
  
  ::v-deep .vs__selected
    padding: 0
    margin: 0
  
  ::v-deep .vs__actions
    display: none

  &:hover, &.vs--open
    ::v-deep .vs__dropdown-toggle
      border-color: #0984e3
      background: white
    ::v-deep .vs__actions
      display: flex

.mx-datepicker
  ::v-deep .mx-input
    border: 1px solid transparent
    background: transparent
    box-shadow: none
    height: 32px
    font-size: 0.85rem
    padding: 4px 8px

.bg-soft-dark
  background: rgba(45, 52, 70, 0.08)

.empty-state
  i
    font-size: 3rem
    opacity: 0.2

.btn-icon
  width: 28px
  height: 28px
  padding: 0
  display: flex
  align-items: center
  justify-content: center
  border-radius: 6px
  font-size: 0.8rem
</style>
